import * as angular from "angular";

let FieldListItemComponent = {
    selector: "vcFieldListItem",
    templateUrl: "/angular/components/field/field-list-item.component.html",
    bindings: {
        field: "<",
        disabled: "<",
        onSetRequired: "&",
        onSetReadOnly: "&",
        onOpenFieldDialog: "&",
        onDeleteField: "&",
    },
};

angular
    .module("field")
    .component(FieldListItemComponent.selector, FieldListItemComponent);
